module.exports = __webpack_public_path__ + "static/media/passport-outline.76d34562.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/passport-outline.svg
// module id = 708
// module chunks = 0